import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const ROWS = [
    { id: 'mock-1', title: 'Rent payment — HQ', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-2', title: 'Client invoice #1042', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-3', title: 'Petty cash — stationery', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
];

export const ACCOUNTING_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/accounting\/transactions(\?|$)/i,
        handler: () => mockSuccess(listPayload(ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/accounting\/transactions\/([^/?]+)/i,
        handler: (req) => {
            const match = req.url.match(/\/transactions\/([^/?]+)/i);
            const id = match ? match[1] : '';
            const row = ROWS.find((r) => r.id === id) ?? ROWS[0];
            return mockSuccess(row);
        },
    },
];
